// 1. 외부 패키지
import { useRecoilValue } from "recoil";

// 2. 프로젝트 내부 alias


// 3. 상대 경로
import media_atom from "../../atom/media-atom";
import watermark from '../../static/img/watermark.png';

// 4. 타입

/**
 * @date   2025-06-11
 * @author 새날_방용환
 * @desc   zoom level 7(1km) 부터 좌측 사이드바 리스트 노출 내용 변경
 *         - zoom level 7 이상이면 리스트 미제공
 *         - zoom level 6 이하부터 리스트 다시 제공
 */
/* eslint-disable @typescript-eslint/no-unused-vars */
const MapSideLevelOver = () => {

  const media = useRecoilValue(media_atom);

  return (
    <div id="map-side-nodata" className="level-over">
      <img className="watermark" src={watermark} alt="공짱 워터마크" />
      <p className="level-over">
        매물 리스트는 1:500m 스케일부터 제공 됩니다.
      </p>
    </div>
  );
};

export default MapSideLevelOver;